export default __webpack_public_path__ + "static/media/backgroundMain.5cd0d2da.png";